import { SnackbarProvider } from 'src/components/snackbar';
import { SettingsProvider } from 'src/components/settings';
import MotionLazy from 'src/components/animate/motion-lazy';
import ProgressBar from 'src/components/progress-bar';
import { DialogProvider } from 'src/components/Dialog/context';
import ThemeProvider from '../theme';

const muiLayout = ({ children }) => (
  <SettingsProvider>
    <ThemeProvider>
      <SnackbarProvider>
        <DialogProvider>
          <MotionLazy>
            <ProgressBar />
            {children}
          </MotionLazy>
        </DialogProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </SettingsProvider>
);

export default muiLayout;
